var $name="getSlugs",$path="app/utilities/getSlugs.js",$this={$name,$path,};/**
 * Returns all path segments for specified pathname.
 * @param { string } pathname
 * @returns { string[] }
 */
const getSlugs = (pathname) => pathname.split('/').filter((slug) => slug);

export default getSlugs;
